import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Creates a carousel with Glide.js.
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Usage
 * -------
 *
 * <div data-controller="carousel">
 *   <div data-glide-el="controls">
 *     <button type="button" data-glide-dir=">">Next</button>
 *     <button type="button" data-glide-dir="<">Previous</button>
 *   </div>
 *   <div data-glide-el="track">
 *     <div>Slide 1</div>
 *     <div>Slide 2</div>
 *     <div>Slide 3</div>
 *   </div>
 * </div>
 */
export default class default_1 extends Controller {
    static values = {
        numberOfSlides: Number,
    };
    async connect() {
        const { default: Glide } = await import('@glidejs/glide');
        const ArrowDisablerPerBreakpoint = (Glide) => {
            const numberOfSlides = this.numberOfSlidesValue;
            return {
                mount() {
                    Glide.on(['mount.after', 'resize'], () => {
                        for (let breakpoint of Object.keys(Glide.settings.breakpoints)) {
                            if (window.matchMedia(`(max-width: ${breakpoint}px)`).matches) {
                                if (numberOfSlides <= Glide.settings.breakpoints[breakpoint].perView) {
                                    Glide.selector.querySelector('[data-glide-dir="<"]').setAttribute('disabled', '');
                                    Glide.selector.querySelector('[data-glide-dir=">"]').setAttribute('disabled', '');
                                }
                                else {
                                    Glide.selector.querySelector('[data-glide-dir="<"]').removeAttribute('disabled');
                                    Glide.selector.querySelector('[data-glide-dir=">"]').removeAttribute('disabled');
                                }
                                break;
                            }
                            else {
                                if (numberOfSlides <= Glide.settings.perView) {
                                    Glide.selector.querySelector('[data-glide-dir="<"]').setAttribute('disabled', '');
                                    Glide.selector.querySelector('[data-glide-dir=">"]').setAttribute('disabled', '');
                                }
                                else {
                                    Glide.selector.querySelector('[data-glide-dir="<"]').removeAttribute('disabled');
                                    Glide.selector.querySelector('[data-glide-dir=">"]').removeAttribute('disabled');
                                }
                            }
                        }
                    });
                },
            };
        };
        new Glide(this.element, {
            type: 'slider',
            perView: 4,
            focusAt: 0,
            startAt: 0,
            bound: true,
            rewind: false,
            keyboard: true,
            gap: 16,
            breakpoints: {
                1024: {
                    perView: 3,
                },
                640: {
                    perView: 2,
                },
            },
            // @ts-ignore
            classes: {
                arrow: {
                    disabled: 'disabled',
                },
            },
        }).mount({ ArrowDisablerPerBreakpoint });
    }
}
